import { Payment } from '@/Domain/Expediente'

export class PaymentDTO {
  private _importe: string | null
  private _importeIva: string | null
  private _dataIngresoAdxudicatario: string | null
  private _dataIngresoIvaPropiedade: string | null
  private _participacionPropiedad: number | null
  private _importePropiedade: string | null
  private _dataPagoPropiedade: string | null
  private _participacionAdministracion: number | null
  private _importeDevolucionAdministracion: string | null
  private _dataPagoAdministracion: string | null

  static fromPayment (p: Payment): PaymentDTO {
    return new PaymentDTO(
      p.importe.toString(),
      p.importeIva.toString(),
      p.dataIngresoAdxudicatario,
      p.dataIngresoIvaPropiedade,
      p.participacionPropiedad,
      p.importePropiedade.toString(),
      p.dataPagoPropiedade,
      p.participacionAdministracion,
      p.importeDevolucionAdministracion.toString(),
      p.dataPagoAdministracion
    )
  }

  constructor (
    importe: string | null,
    importeIva: string | null,
    dataIngresoAdxudicatario: string | null,
    dataIngresoIvaPropiedade: string | null,
    participacionPropiedad: number | null,
    importePropiedade: string | null,
    dataPagoPropiedade: string | null,
    participacionAdministracion: number | null,
    importeDevolucionAdministracion: string | null,
    dataPagoAdministracion: string | null
  ) {
    this._importe = importe
    this._importeIva = importeIva
    this._dataIngresoAdxudicatario = dataIngresoAdxudicatario
    this._dataIngresoIvaPropiedade = dataIngresoIvaPropiedade
    this._participacionPropiedad = participacionPropiedad
    this._importePropiedade = importePropiedade
    this._dataPagoPropiedade = dataPagoPropiedade
    this._participacionAdministracion = participacionAdministracion
    this._importeDevolucionAdministracion = importeDevolucionAdministracion
    this._dataPagoAdministracion = dataPagoAdministracion
  }

  get importe (): string {
    return this._importe !== null
      ? this._importe
      : ''
  }

  get importeIva (): string {
    return this._importeIva !== null
      ? this._importeIva
      : ''
  }

  get dataIngresoAdxudicatario (): string {
    if (this._dataIngresoAdxudicatario !== null) {
      return this._dataIngresoAdxudicatario
    } else { return '' }
  }

  get dataIngresoIvaPropiedade (): string {
    if (this._dataIngresoIvaPropiedade !== null) {
      return this._dataIngresoIvaPropiedade
    } else { return '' }
  }

  get participacionPropiedad (): number {
    if (this._participacionPropiedad !== null) {
      return this._participacionPropiedad
    } else { return 0 }
  }

  get importePropiedade (): string {
    return this._importePropiedade !== null
      ? this._importePropiedade
      : ''
  }

  get dataPagoPropiedade (): string {
    if (this._dataPagoPropiedade !== null) {
      return this._dataPagoPropiedade
    } else { return '' }
  }

  get participacionAdministracion (): number {
    if (this._participacionAdministracion !== null) {
      return this._participacionAdministracion
    } else { return 0 }
  }

  get importeDevolucionAdministracion (): string {
    return this._importeDevolucionAdministracion !== null
      ? this._importeDevolucionAdministracion
      : ''
  }

  get dataPagoAdministracion (): string {
    if (this._dataPagoAdministracion !== null) {
      return this._dataPagoAdministracion
    } else { return '' }
  }
}
